// Asset URLs are injected via data attributes on <body> in theme.liquid

// ==========================================
// SHOPIFY CONFIGURATION - UPDATE THESE VALUES
// ==========================================
const SHOPIFY_CONFIG = {
    // Your store's checkout domain (custom domain or myshopify.com)
    // Use your custom domain if you have one, otherwise use myshopify.com
    storeDomain: 'ec52b5-c8.myshopify.com',

    // Use single can variant — 4-pack = qty 4, 8-pack = qty 8, 12-pack = qty 12
    singleCanVariantId: '52062588829978',

    variantIds: {
        'Sparkling Matcha (4 pack)': '52062588829978',
        'Tote': '52059251540250',
        'Hoodie (S)': '51653296423194',
        'Hoodie (M)': '51653296455962',
        'Hoodie (L)': '51653296488730',
        'Hoodie (XL)': '51653296521498',
    },

    // Matcha quantities map: cart qty → actual cans to add
    matchaCanMultiplier: 4
};

// ==========================================
// SHOPIFY CART PERMALINK CHECKOUT
// ==========================================
// This uses Shopify's cart permalink feature - no API token needed!
// Format: https://store.com/cart/VARIANT_ID:QUANTITY,VARIANT_ID:QUANTITY

// Add items to Shopify cart via AJAX API, then redirect to checkout
async function addToShopifyCartAndCheckout(cartItems) {
    // Clear Shopify cart first
    await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });

    // Build items array for Shopify
    const items = [];
    for (const item of cartItems) {
        const variantId = SHOPIFY_CONFIG.variantIds[item.name];
        if (!variantId) {
            console.warn('No variant ID for:', item.name);
            continue;
        }
        // Matcha "4-pack" = 4 single cans, so multiply quantity
        const isMatcha = item.name === 'Sparkling Matcha (4 pack)';
        const qty = isMatcha ? item.quantity * SHOPIFY_CONFIG.matchaCanMultiplier : item.quantity;
        items.push({ id: parseInt(variantId), quantity: qty });
    }

    if (items.length === 0) return false;

    // Add all items to Shopify cart
    const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
    });

    if (resp.ok) {
        window.location.href = '/checkout';
        return true;
    }
    return false;
}

// ==========================================
// MAIN SITE CODE
// ==========================================

// Can Rotator Class - handles 4-angle image rotation
class CanRotator {
    constructor(element, options = {}) {
        this.container = element;
        this.frames = Array.from(element.querySelectorAll('.can-frame'));
        this.angles = [0, 90, 180, 270];
        this.currentAngle = 0;
        this.targetAngle = 0;
        this.isDragging = false;
        this.startX = 0;
        this.autoRotate = options.autoRotate || false;
        this.autoRotateSpeed = options.autoRotateSpeed || 0.3; // degrees per frame
        this.sensitivity = options.sensitivity || 0.5;

        this.init();
    }

    init() {
        // Mouse events
        this.container.addEventListener('mousedown', (e) => this.onDragStart(e));
        document.addEventListener('mousemove', (e) => this.onDragMove(e));
        document.addEventListener('mouseup', () => this.onDragEnd());

        // Touch events
        this.container.addEventListener('touchstart', (e) => this.onDragStart(e), { passive: true });
        document.addEventListener('touchmove', (e) => this.onDragMove(e), { passive: true });
        document.addEventListener('touchend', () => this.onDragEnd());

        // Prevent context menu
        this.container.addEventListener('contextmenu', (e) => e.preventDefault());

        // Start animation loop
        this.animate();

        // Start auto-rotate if enabled
        if (this.autoRotate) {
            this.startAutoRotate();
        }
    }

    onDragStart(e) {
        this.isDragging = true;
        this.startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        this.startAngle = this.currentAngle;
        this.container.style.cursor = 'grabbing';

        // Pause auto-rotate while dragging
        if (this.autoRotate) {
            this.pauseAutoRotate();
        }
    }

    onDragMove(e) {
        if (!this.isDragging) return;

        const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
        const deltaX = clientX - this.startX;
        this.targetAngle = this.startAngle + (deltaX * this.sensitivity);

        // Normalize angle to 0-360
        while (this.targetAngle < 0) this.targetAngle += 360;
        while (this.targetAngle >= 360) this.targetAngle -= 360;
    }

    onDragEnd() {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.container.style.cursor = 'grab';

        // Resume auto-rotate after a delay
        if (this.autoRotate) {
            setTimeout(() => this.startAutoRotate(), 2000);
        }
    }

    startAutoRotate() {
        this.isAutoRotating = true;
    }

    pauseAutoRotate() {
        this.isAutoRotating = false;
    }

    animate() {
        // Auto-rotate
        if (this.isAutoRotating && !this.isDragging) {
            this.targetAngle += this.autoRotateSpeed;
            if (this.targetAngle >= 360) this.targetAngle -= 360;
        }

        // Smooth interpolation
        let diff = this.targetAngle - this.currentAngle;

        // Handle wrapping
        if (diff > 180) diff -= 360;
        if (diff < -180) diff += 360;

        this.currentAngle += diff * 0.1;

        // Normalize
        while (this.currentAngle < 0) this.currentAngle += 360;
        while (this.currentAngle >= 360) this.currentAngle -= 360;

        // Update frame visibility with crossfade
        this.updateFrames();

        requestAnimationFrame(() => this.animate());
    }

    updateFrames() {
        // Find the two nearest angles for crossfade
        const angle = this.currentAngle;

        // Determine which two frames to show
        let lowerIndex, upperIndex, blend;

        if (angle < 90) {
            lowerIndex = 0; // 0°
            upperIndex = 1; // 90°
            blend = angle / 90;
        } else if (angle < 180) {
            lowerIndex = 1; // 90°
            upperIndex = 2; // 180°
            blend = (angle - 90) / 90;
        } else if (angle < 270) {
            lowerIndex = 2; // 180°
            upperIndex = 3; // 270°
            blend = (angle - 180) / 90;
        } else {
            lowerIndex = 3; // 270°
            upperIndex = 0; // 0° (wrap around)
            blend = (angle - 270) / 90;
        }

        // Update all frames
        this.frames.forEach((frame, index) => {
            if (index === lowerIndex) {
                frame.style.opacity = 1 - blend;
                frame.style.zIndex = 1;
            } else if (index === upperIndex) {
                frame.style.opacity = blend;
                frame.style.zIndex = 2;
            } else {
                frame.style.opacity = 0;
                frame.style.zIndex = 0;
            }
        });
    }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    // Hide model-viewer pan target dots
    document.querySelectorAll('model-viewer').forEach(mv => {
        const hide = () => {
            if (mv.shadowRoot) {
                const pt = mv.shadowRoot.querySelector('#default-pan-target');
                if (pt) pt.style.display = 'none';
            }
        };
        hide();
        mv.addEventListener('load', hide);
        setTimeout(hide, 1000);
    });

    // Hero can with auto-rotate
    const heroRotator = document.getElementById('heroCanRotator');
    if (heroRotator) {
        new CanRotator(heroRotator, {
            autoRotate: true,
            autoRotateSpeed: 0.2,
            sensitivity: 0.5
        });
    }

    // Product cans (no auto-rotate, just drag)
    const productRotators = document.querySelectorAll('.can-rotator.small');
    productRotators.forEach(rotator => {
        new CanRotator(rotator, {
            autoRotate: false,
            sensitivity: 0.5
        });
    });

    // Nav scroll effect
    const nav = document.getElementById('nav');
    if (nav) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                nav.classList.add('scrolled');
            } else {
                nav.classList.remove('scrolled');
            }
        });
    }

    // Shop Now scroll handled by inline script in index.html

    // Smooth scroll for navigation (exclude add to cart buttons)
    document.querySelectorAll('a[href^="#"]:not(.btn-add-cart):not(#shop-now-btn)').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            // Rain matcha if it's the merch button
            if (this.classList.contains('btn-merch')) {
                rainMatcha();
            }

            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // Cart functionality
    let cart = [];
    const cartBtn = document.getElementById('cart-btn');
    const cartCountEl = document.getElementById('cart-count');
    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartItemsEl = document.getElementById('cart-items');
    const cartTotalEl = document.getElementById('cart-total-price');
    const cartCloseBtn = document.getElementById('cart-close');

    // Open cart drawer
    cartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        updateCartDisplay(); // Ensure contents are fresh (upsell pill, totals, etc.)
        cartDrawer.classList.add('open');
        cartOverlay.classList.add('visible');
    });

    // Tote add-to-cart
    document.addEventListener('tote-add-to-cart', function() {
        const name = 'Tote';
        const price = 49;
        const existingItem = cart.find(i => i.name === name);
        if (existingItem) {
            existingItem.quantity++;
        } else {
            cart.push({ name, price, quantity: 1 });
        }
        rainMatcha();
        updateCartDisplay();
        cartBtn.classList.add('visible');
        setTimeout(() => {
            cartDrawer.classList.add('open');
            cartOverlay.classList.add('visible');
        }, 600);
    });

    // Hoodie add-to-cart from size selector
    document.addEventListener('hoodie-add-to-cart', function(e) {
        const size = e.detail.size;
        const name = 'Hoodie (' + size + ')';
        const price = 99;
        const existingItem = cart.find(i => i.name === name);
        if (existingItem) {
            existingItem.quantity++;
        } else {
            cart.push({ name, price, quantity: 1 });
        }
        rainMatcha();
        updateCartDisplay();
        cartBtn.classList.add('visible');
        // Auto-open cart drawer
        setTimeout(() => {
            cartDrawer.classList.add('open');
            cartOverlay.classList.add('visible');
        }, 600);
    });

    // Close cart drawer
    function closeCart() {
        cartDrawer.classList.remove('open');
        cartOverlay.classList.remove('visible');
    }

    cartCloseBtn.addEventListener('click', closeCart);
    cartOverlay.addEventListener('click', closeCart);

    // Tiered pricing for Sparkling Matcha 4-packs
    // Base price: $20 per 4-pack
    // 2+ 4-packs (8+ cans): 10% off
    // 3+ 4-packs (12+ cans): 20% off
    const MATCHA_BASE_PRICE = 21;
    const MATCHA_ITEM_NAME = 'Sparkling Matcha (4 pack)';

    function getMatchaPrice(quantity) {
        if (quantity >= 3) return MATCHA_BASE_PRICE * 0.80; // 20% off
        if (quantity >= 2) return MATCHA_BASE_PRICE * 0.90; // 10% off
        return MATCHA_BASE_PRICE;
    }

    function getMatchaDiscount(quantity) {
        if (quantity >= 3) return 20;
        if (quantity >= 2) return 10;
        return 0;
    }

    function getNextTierMessage(quantity) {
        if (quantity >= 3) return null; // Already at max discount
        if (quantity === 2) return 'Add 1 more 4-pack to save 20%!';
        if (quantity === 1) return 'Add 1 more 4-pack to save 10%!';
        return null;
    }

    // Update cart display
    function updateCartDisplay() {
        // Count total items
        const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
        cartCountEl.textContent = totalItems;

        if (cart.length === 0) {
            cartItemsEl.innerHTML = '<p class="cart-empty">Your cart is empty</p>';
            cartTotalEl.textContent = '$0';
        } else {
            // Find matcha item for special pricing
            const matchaItem = cart.find(i => i.name === MATCHA_ITEM_NAME);
            const matchaQty = matchaItem ? matchaItem.quantity : 0;
            const matchaDiscount = getMatchaDiscount(matchaQty);
            const nextTierMsg = getNextTierMessage(matchaQty);

            cartItemsEl.innerHTML = cart.map((item, index) => {
                const isMatcha = item.name === MATCHA_ITEM_NAME;
                const unitPrice = isMatcha ? getMatchaPrice(item.quantity) : item.price;
                const itemTotal = unitPrice * item.quantity;
                const originalTotal = isMatcha ? MATCHA_BASE_PRICE * item.quantity : itemTotal;
                const showSavings = isMatcha && matchaDiscount > 0;
                const showUpsell = isMatcha && nextTierMsg;

                const isHoodie = item.name.startsWith('Hoodie (');
                const currentSize = isHoodie ? item.name.match(/\((\w+)\)/)?.[1] : null;
                const sizeDropdown = isHoodie ? `
                    <select class="cart-size-select" data-index="${index}">
                        ${['S','M','L','XL'].map(s => `<option value="${s}" ${s === currentSize ? 'selected' : ''}>${s}</option>`).join('')}
                    </select>` : '';

                return `
                <div class="cart-item">
                    <div class="cart-item-info">
                        <span class="cart-item-name">${isHoodie ? 'Hover Hoodie' : item.name} ${sizeDropdown}</span>
                        <span class="cart-item-price">
                            ${showSavings ? `<span class="price-original">$${originalTotal.toFixed(2)}</span>` : ''}
                            $${itemTotal.toFixed(2)}
                            ${showSavings ? `<span class="price-savings">${matchaDiscount}% off</span>` : ''}
                        </span>
                    </div>
                    <div class="cart-item-controls">
                        <div class="quantity-control">
                            <button class="qty-btn qty-minus" data-index="${index}">−</button>
                            <span class="qty-value">${item.quantity}</span>
                            <button class="qty-btn qty-plus" data-index="${index}">+</button>
                        </div>
                        <button class="cart-item-remove" data-index="${index}">✕</button>
                    </div>
                </div>
                ${showUpsell ? `<div class="cart-upsell">${nextTierMsg}</div>` : ''}
            `}).join('');

            // Add quantity listeners
            cartItemsEl.querySelectorAll('.qty-minus').forEach(btn => {
                btn.addEventListener('click', function() {
                    const index = parseInt(this.dataset.index);
                    if (cart[index].quantity > 1) {
                        cart[index].quantity--;
                        updateCartDisplay();
                    }
                });
            });

            cartItemsEl.querySelectorAll('.qty-plus').forEach(btn => {
                btn.addEventListener('click', function() {
                    const index = parseInt(this.dataset.index);
                    cart[index].quantity++;
                    updateCartDisplay();
                });
            });

            // Add remove listeners
            cartItemsEl.querySelectorAll('.cart-item-remove').forEach(btn => {
                btn.addEventListener('click', function() {
                    const index = parseInt(this.dataset.index);
                    cart.splice(index, 1);
                    updateCartDisplay();
                    if (cart.length === 0) {
                        cartBtn.classList.remove('visible');
                    }
                });
            });

            // Hoodie size change
            cartItemsEl.querySelectorAll('.cart-size-select').forEach(sel => {
                sel.addEventListener('change', function() {
                    const index = parseInt(this.dataset.index);
                    const newSize = this.value;
                    const newName = 'Hoodie (' + newSize + ')';
                    // Check if that size already exists in cart
                    const existing = cart.find((item, i) => i !== index && item.name === newName);
                    if (existing) {
                        existing.quantity += cart[index].quantity;
                        cart.splice(index, 1);
                    } else {
                        cart[index].name = newName;
                    }
                    updateCartDisplay();
                });
            });

            // Calculate total with tiered pricing
            const total = cart.reduce((sum, item) => {
                if (item.name === MATCHA_ITEM_NAME) {
                    return sum + (getMatchaPrice(item.quantity) * item.quantity);
                }
                return sum + (item.price * item.quantity);
            }, 0);
            cartTotalEl.textContent = '$' + total.toFixed(2);

            // Update free shipping barometer
            const FREE_SHIPPING_THRESHOLD = 100;
            const shippingBarometer = document.getElementById('shipping-barometer');
            if (shippingBarometer) {
                const remaining = FREE_SHIPPING_THRESHOLD - total;
                const progress = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);

                if (remaining <= 0) {
                    shippingBarometer.innerHTML = `
                        <div class="shipping-text shipping-success">🎉 You've unlocked FREE shipping!</div>
                        <div class="shipping-bar"><div class="shipping-progress" style="width: 100%"></div></div>
                    `;
                } else {
                    shippingBarometer.innerHTML = `
                        <div class="shipping-text">You're <strong>$${remaining.toFixed(2)}</strong> away from FREE shipping!</div>
                        <div class="shipping-bar"><div class="shipping-progress" style="width: ${progress}%"></div></div>
                    `;
                }
            }

            // Cross-sell suggestions
            const upsellContainer = document.getElementById('cart-upsells');
            if (upsellContainer) {
                const hasMatcha = cart.some(i => i.name === MATCHA_ITEM_NAME);
                const hasTote = cart.some(i => i.name === 'Tote');
                const hasHoodie = cart.some(i => i.name.startsWith('Hoodie ('));

                const suggestions = [];

                if (!hasMatcha) {
                    suggestions.push({
                        name: 'Sparkling Matcha (4 pack)',
                        label: 'Sparkling Matcha 4-Pack',
                        price: '$20',
                        action: 'add-matcha',
                        glb: document.body.dataset.canGlb || 'images/can.glb'
                    });
                }
                if (!hasHoodie) {
                    suggestions.push({
                        name: 'Hoodie',
                        label: 'Hover Hoodie',
                        price: '$99',
                        action: 'add-hoodie',
                        glb: document.body.dataset.hoodieGlb || 'hoodie.glb'
                    });
                }
                if (!hasTote) {
                    suggestions.push({
                        name: 'Tote',
                        label: 'Hover Tote',
                        price: '$49',
                        action: 'add-tote',
                        glb: document.body.dataset.toteGlb || 'tote.glb'
                    });
                }

                if (suggestions.length > 0) {
                    upsellContainer.innerHTML = `
                        <p class="upsell-heading">Complete your order</p>
                        ${suggestions.map(s => `
                            <div class="upsell-item">
                                <model-viewer
                                    src="${s.glb}"
                                    auto-rotate
                                    auto-rotate-delay="0"
                                    rotation-per-second="30deg"
                                    interaction-prompt="none"
                                    shadow-intensity="0.3"
                                    camera-orbit="0deg 82deg auto"
                                    min-camera-orbit="auto 82deg auto"
                                    max-camera-orbit="auto 82deg auto"
                                    disable-zoom
                                    disable-pan
                                    style="width:64px;height:64px;background:transparent;flex-shrink:0;"
                                ></model-viewer>
                                <div class="upsell-info">
                                    <span class="upsell-name">${s.label}</span>
                                    <span class="upsell-price">${s.price}</span>
                                </div>
                                <button class="upsell-add" data-action="${s.action}">+ Add</button>
                            </div>
                        `).join('')}
                    `;

                    // Attach upsell click handlers
                    upsellContainer.querySelectorAll('.upsell-add').forEach(btn => {
                        btn.addEventListener('click', function() {
                            const action = this.dataset.action;
                            if (action === 'add-matcha') {
                                var existingMatcha = cart.find(function(i) { return i.name === MATCHA_ITEM_NAME; });
                                if (existingMatcha) {
                                    existingMatcha.quantity += 1;
                                } else {
                                    cart.push({ name: MATCHA_ITEM_NAME, price: MATCHA_BASE_PRICE, quantity: 1 });
                                }
                                rainMatcha();
                            } else if (action === 'add-tote') {
                                cart.push({ name: 'Tote', price: 49, quantity: 1 });
                                rainMatcha();
                            } else if (action === 'add-hoodie') {
                                // Default to M, they can change in cart
                                cart.push({ name: 'Hoodie (M)', price: 99, quantity: 1 });
                                rainMatcha();
                            }
                            updateCartDisplay();
                        });
                    });
                } else {
                    upsellContainer.innerHTML = '';
                }
            }
        }
    }

    // Inventory management - will be populated from Shopify API
    // Structure: { 'Product Name': { inStock: true, sizes: { S: true, M: true, L: false, XL: true } } }
    // For products without sizes, just use inStock
    const inventory = {
        'Sparkling Matcha (4 pack)': { inStock: true },
        'Tote': { inStock: true },
        'Hoodie': { inStock: true, sizes: { S: true, M: true, L: true, XL: true } },
    };

    // TODO: Fetch inventory from Shopify API
    // async function fetchInventory() {
    //     const response = await fetch('YOUR_SHOPIFY_STOREFRONT_API_ENDPOINT');
    //     const data = await response.json();
    //     // Map Shopify inventory to our inventory object
    //     // Update inventory object and UI
    //     updateInventoryUI();
    // }

    // Update UI based on inventory
    function updateInventoryUI() {
        document.querySelectorAll('.showcase-item').forEach(item => {
            const productName = item.querySelector('.placeholder-3d span').textContent;
            const productInventory = inventory[productName];
            const addBtn = item.querySelector('.btn-add-cart');

            if (productInventory && !productInventory.inStock) {
                addBtn.textContent = 'Sold Out';
                addBtn.classList.add('sold-out');
                addBtn.disabled = true;
            }
        });
    }

    // Update size buttons based on product inventory
    function updateSizeButtonsForProduct(productName) {
        const productInventory = inventory[productName];
        if (!productInventory || !productInventory.sizes) return;

        sizeBtns.forEach(btn => {
            const size = btn.dataset.size;
            if (productInventory.sizes[size] === false) {
                btn.classList.add('sold-out');
                btn.disabled = true;
            } else {
                btn.classList.remove('sold-out');
                btn.disabled = false;
            }
        });
    }

    // Run on page load
    updateInventoryUI();

    // Size modal elements
    const sizeModal = document.getElementById('size-modal');
    const sizeModalOverlay = document.getElementById('size-modal-overlay');
    const sizeModalClose = document.getElementById('size-modal-close');
    const sizeBtns = document.querySelectorAll('.size-btn');
    let pendingProduct = null;

    // Buy Everything queue tracking
    let buyEverythingQueue = [];
    let isBuyEverythingMode = false;

    // Close size modal
    function closeSizeModal() {
        sizeModal.classList.remove('visible');
        sizeModalOverlay.classList.remove('visible');
        pendingProduct = null;
        sizeBtns.forEach(btn => btn.classList.remove('selected'));
        // Reset modal title
        const modalTitle = sizeModal.querySelector('h3');
        modalTitle.textContent = 'Select Size';
    }

    // Cancel Buy Everything mode when manually closing
    function cancelBuyEverything() {
        buyEverythingQueue = [];
        isBuyEverythingMode = false;
        closeSizeModal();
    }

    sizeModalClose.addEventListener('click', cancelBuyEverything);
    sizeModalOverlay.addEventListener('click', cancelBuyEverything);

    // Show next size modal in queue (for Buy Everything)
    function showNextSizeModal() {
        if (buyEverythingQueue.length === 0) {
            // All done!
            isBuyEverythingMode = false;
            const buyEverythingBtn = document.getElementById('btn-buy-everything');
            if (buyEverythingBtn) {
                buyEverythingBtn.textContent = 'Added Everything! 🎉';
                setTimeout(() => {
                    buyEverythingBtn.textContent = 'BUY EVERYTHING';
                }, 2000);
            }
            return;
        }

        const nextItem = buyEverythingQueue.shift();
        pendingProduct = { name: nextItem.name, price: nextItem.price, button: null, isBuyEverything: true };
        updateSizeButtonsForProduct(nextItem.name);

        // Update modal title to show which product
        const modalTitle = sizeModal.querySelector('h3');
        modalTitle.textContent = `Select ${nextItem.name} Size`;

        sizeModal.classList.add('visible');
        sizeModalOverlay.classList.add('visible');
    }

    // Size button click - immediately add to cart
    sizeBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            if (this.disabled || !pendingProduct) return;

            const selectedSize = this.dataset.size;

            // Visual feedback on size button
            this.classList.add('selected');

            if (!pendingProduct.isBuyEverything) {
                rainMatcha();
            }

            const name = `${pendingProduct.name} (${selectedSize})`;
            const price = pendingProduct.price;

            // Add to cart (check if already exists with same size)
            const existingItem = cart.find(i => i.name === name);
            if (existingItem) {
                existingItem.quantity++;
            } else {
                cart.push({ name, price, quantity: 1 });
            }
            updateCartDisplay();
            cartBtn.classList.add('visible');

            // Flash the original button (if not Buy Everything mode)
            if (pendingProduct.button) {
                const originalBtn = pendingProduct.button;
                const originalText = originalBtn.textContent;
                originalBtn.textContent = 'Added! 🍵';
                originalBtn.style.background = '#f0dc82';
                originalBtn.style.color = '#4cb050';

                setTimeout(() => {
                    originalBtn.textContent = originalText;
                    originalBtn.style.background = '';
                    originalBtn.style.color = '';
                }, 2000);
            }

            const wasInBuyEverythingMode = isBuyEverythingMode;

            // Close modal after short delay for feedback
            setTimeout(() => {
                closeSizeModal();

                // If in Buy Everything mode, show next size modal
                if (wasInBuyEverythingMode) {
                    isBuyEverythingMode = true; // Re-enable since closeSizeModal doesn't cancel it
                    setTimeout(() => {
                        showNextSizeModal();
                    }, 200);
                }
            }, 300);
        });
    });

    // Legacy .btn-add-cart handler removed — it referenced .showcase-item markup
    // that no longer exists in the theme, so every click threw a TypeError before
    // updateCartDisplay() could run. The hero Add to Cart button has its own
    // dedicated handler (#hero-add-cart) below.


    // Footer email signup — Klaviyo
    const footerSignupForm = document.getElementById('footer-signup-form');
    if (footerSignupForm) {
        footerSignupForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            const emailInput = document.getElementById('footer-signup-email');
            const btn = document.getElementById('footer-signup-btn');
            const email = emailInput.value.trim();
            if (!email) return;

            btn.disabled = true;
            btn.textContent = '...';

            try {
                const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=QTzqFq', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
                    body: JSON.stringify({
                        data: {
                            type: 'subscription',
                            attributes: {
                                profile: {
                                    data: {
                                        type: 'profile',
                                        attributes: { email }
                                    }
                                }
                            },
                            relationships: {
                                list: {
                                    data: { type: 'list', id: 'U43bfU' }
                                }
                            }
                        }
                    })
                });

                if (res.ok || res.status === 202) {
                    btn.textContent = "You're in!";
                    emailInput.value = '';
                    emailInput.placeholder = 'check your inbox';
                    // Identify user for Klaviyo tracking (links email to browser cookie)
                    var _learnq = window._learnq || [];
                    _learnq.push(['identify', { '$email': email }]);
                    // Show discount code popup
                    showDiscountPopup();
                } else {
                    btn.textContent = 'Try again';
                }
            } catch {
                btn.textContent = 'Try again';
            }

            setTimeout(() => {
                btn.disabled = false;
                if (btn.textContent !== "You're in!") btn.textContent = 'Sign Up';
            }, 3000);
        });
    }

    // Discount code popup
    function showDiscountPopup() {
        const popup = document.getElementById('discount-popup');
        const overlay = document.getElementById('discount-overlay');
        if (popup && overlay) {
            popup.classList.add('visible');
            overlay.classList.add('visible');
        }
    }

    function closeDiscountPopup() {
        const popup = document.getElementById('discount-popup');
        const overlay = document.getElementById('discount-overlay');
        if (popup && overlay) {
            popup.classList.remove('visible');
            overlay.classList.remove('visible');
        }
    }

    const discountClose = document.getElementById('discount-close');
    const discountOverlay = document.getElementById('discount-overlay');
    const discountCopy = document.getElementById('discount-copy');
    const discountCode = document.getElementById('discount-code');

    if (discountClose) discountClose.addEventListener('click', closeDiscountPopup);
    if (discountOverlay) discountOverlay.addEventListener('click', closeDiscountPopup);

    if (discountCopy) {
        discountCopy.addEventListener('click', function() {
            navigator.clipboard.writeText('HOVER10').then(() => {
                this.textContent = 'Copied!';
                setTimeout(() => { this.textContent = 'Copy Code'; }, 2000);
            });
        });
    }

    if (discountCode) {
        discountCode.addEventListener('click', function() {
            navigator.clipboard.writeText('HOVER10').then(() => {
                discountCopy.textContent = 'Copied!';
                setTimeout(() => { discountCopy.textContent = 'Copy Code'; }, 2000);
            });
        });
    }

    // Bundle selector
    let selectedBundleQty = 1;
    let selectedBundlePrice = 21;
    const bundleBtns = document.querySelectorAll('.bundle-btn');
    const priceAmountEl = document.querySelector('.price-amount');
    const priceDetailEl = document.querySelector('.price-detail');
    const heroAddCart = document.getElementById('hero-add-cart');

    bundleBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            bundleBtns.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            selectedBundleQty = parseInt(this.dataset.qty);
            selectedBundlePrice = parseInt(this.dataset.price);
            const total = selectedBundlePrice * selectedBundleQty;
            if (priceAmountEl) priceAmountEl.textContent = '$' + total;
            if (priceDetailEl) {
                const cans = selectedBundleQty * 4;
                const perCan = (selectedBundlePrice / 4).toFixed(2);
                priceDetailEl.textContent = cans + ' cans · $' + perCan + '/can';
            }
            if (heroAddCart) heroAddCart.dataset.price = selectedBundlePrice;
        });
    });

    // Hero Add to Cart
    if (heroAddCart) {
        heroAddCart.addEventListener('click', function(e) {
            e.preventDefault();
            rainMatcha();

            const name = 'Sparkling Matcha (4 pack)';
            const price = selectedBundlePrice;

            const existingItem = cart.find(i => i.name === name);
            if (existingItem) {
                existingItem.quantity += selectedBundleQty;
            } else {
                cart.push({ name, price, quantity: selectedBundleQty });
            }
            updateCartDisplay();

            // Klaviyo: track Added to Cart
            if (window.klaviyo) {
                var _learnq = window._learnq || [];
                _learnq.push(['track', 'Added to Cart', {
                    '$value': price * selectedBundleQty,
                    'ItemName': name,
                    'ItemPrice': price,
                    'ItemQuantity': selectedBundleQty,
                    'ItemURL': window.location.href,
                    'CheckoutURL': window.location.origin + '/hover-matcha/'
                }]);
            }

            // Show count badge
            if (cartCountEl) cartCountEl.classList.add('visible');

            const originalText = this.textContent;
            this.textContent = 'Added!';
            this.style.background = 'var(--yuzu-yellow)';
            this.style.color = 'var(--hover-green)';

            // Open cart drawer after brief delay
            setTimeout(() => {
                cartDrawer.classList.add('open');
                cartOverlay.classList.add('visible');
            }, 600);

            setTimeout(() => {
                this.textContent = originalText;
                this.style.background = '';
                this.style.color = '';
            }, 2000);
        });
    }

    // Buy Everything button
    const buyEverythingBtn = document.getElementById('btn-buy-everything');
    if (buyEverythingBtn) {
        buyEverythingBtn.addEventListener('click', function(e) {
            e.preventDefault();

            // Extra matcha rain for the big purchase!
            rainMatcha();
            setTimeout(() => rainMatcha(), 500);
            setTimeout(() => rainMatcha(), 1000);

            // Add Sparkling Matcha 4-pack
            const matchaItem = cart.find(i => i.name === 'Sparkling Matcha (4 pack)');
            if (matchaItem) {
                matchaItem.quantity++;
            } else {
                cart.push({ name: 'Sparkling Matcha (4 pack)', price: 20, quantity: 1 });
            }

            // Add non-sized merch items immediately
            const nonSizedItems = [
                { name: 'Tote', price: 49 }
            ];

            nonSizedItems.forEach(merch => {
                const existingItem = cart.find(i => i.name === merch.name);
                if (existingItem) {
                    existingItem.quantity++;
                } else {
                    cart.push({ name: merch.name, price: merch.price, quantity: 1 });
                }
            });

            updateCartDisplay();
            cartBtn.classList.add('visible');

            // Queue sized items - Hoodie
            buyEverythingQueue = [
                { name: 'Hoodie', price: 10 }
            ];
            isBuyEverythingMode = true;

            // Start with Hoodie size selection
            showNextSizeModal();
        });
    }

    // Checkout button - redirect to Shopify cart
    const checkoutBtn = document.getElementById('btn-checkout');
    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function(e) {
            e.preventDefault();

            // Check if cart is empty
            if (cart.length === 0) {
                this.textContent = 'Cart is empty!';
                setTimeout(() => {
                    this.textContent = 'Checkout';
                }, 2000);
                return;
            }

            // Check if any products have variant IDs configured
            const hasConfiguredProducts = cart.some(item =>
                SHOPIFY_CONFIG.variantIds[item.name] && SHOPIFY_CONFIG.variantIds[item.name] !== ''
            );

            if (!hasConfiguredProducts) {
                // Not configured - show message
                this.textContent = 'Coming Soon!';
                this.style.background = '#f0dc82';
                this.style.color = '#4cb050';
                setTimeout(() => {
                    this.textContent = 'Checkout';
                    this.style.background = '';
                    this.style.color = '';
                }, 2000);
                console.log('Shopify variant IDs not configured. Cart contents:', cart);
                return;
            }

            // Add to Shopify cart and redirect to checkout
            this.textContent = 'Redirecting...';
            addToShopifyCartAndCheckout(cart).catch(function() {
                this.textContent = 'Error - try again';
            });
        });
    }

});

// Matcha rain function
function rainMatcha() {
    var TOMBO_SRC = document.body.dataset.tomboSrc || 'images/tombo-cursor.png';
    var emojis = ['🍵', '💚'];
    var itemCount = 50;

    for (var i = 0; i < itemCount; i++) {
        (function(idx) {
            setTimeout(function() {
                var item = document.createElement('div');
                item.className = 'matcha-rain';
                item.style.left = Math.random() * 100 + 'vw';
                item.style.animationDuration = (Math.random() * 2 + 2) + 's';

                if (Math.random() > 0.3) {
                    item.textContent = emojis[Math.floor(Math.random() * emojis.length)];
                    item.style.fontSize = (Math.random() * 20 + 20) + 'px';
                } else {
                    var img = document.createElement('img');
                    img.src = TOMBO_SRC;
                    img.style.width = (Math.random() * 40 + 30) + 'px';
                    img.style.height = 'auto';
                    img.onerror = function() { item.textContent = '💚'; item.style.fontSize = '24px'; };
                    item.appendChild(img);
                }

                document.body.appendChild(item);
                setTimeout(function() { item.remove(); }, 4000);
            }, idx * 50);
        })(i);
    }
}

// Tab visibility - change title when user leaves/returns
const originalTitle = 'Hover Matcha';
const awayTitle = 'We miss you, come back 💚';

document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
        document.title = awayTitle;
    } else {
        document.title = originalTitle;
    }
});

// Infinite loop review carousel on mobile
(function() {
    if (window.innerWidth >= 600) return;
    const grid = document.querySelector('.reviews-grid');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('.review-card'));
    if (cards.length < 2) return;

    // Clone cards multiple times so there's always more to swipe to
    for (let i = 0; i < 4; i++) {
        cards.forEach(function(card) {
            grid.appendChild(card.cloneNode(true));
        });
    }

    // When user scrolls near the end, append more clones
    grid.addEventListener('scroll', function() {
        var scrollRight = grid.scrollWidth - grid.scrollLeft - grid.clientWidth;
        if (scrollRight < 300) {
            cards.forEach(function(card) {
                grid.appendChild(card.cloneNode(true));
            });
        }
    });
})();
